import React, { useState, useEffect, memo } from 'react';
import Accordion from './components/accordion/Accordion';
import CheckBox from './shared/check-box/Check-box';
import Search from './shared/input/Search';
import SearchRsult from './components/search-result/SearchResult';
import Disclaimer from './components/disclaimer/Disclaimer';
import ErrorList from './components/error-list/error-list';
import Loader from './components/loader/Loader';
import { ThemeProvider } from './hooks/theme';
import { setTheme } from 'mondrian-react';
import { useCallback } from 'react';
import api from '../services/api';
import Heading from './shared/heading/Heading';

const App = (props) => {
  const { pathName, tvName } = props;

  const [urlParameters] = useState({
    tvId: props.tvId,
    zipCode: props.zipcode,
    number: props.number,
    theme: props.theme || 'index',
  });

  const [planoSelecionado] = useState('');
  const [categorias] = useState([]);
  const [categoriaAberta, setCategoriaAberta] = useState('');
  const [canaisDoPlano, setCanaisDoPlano] = useState({});
  const [busca, setBusca] = useState('');
  const [planName, setplanName] = useState('');
  const [disclaimerOpen, setDisclaimerOpen] = useState(false);
  const [listErrors, setListErrors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [themeMy] = useState(props.theme || 'index');
  const [isValid, setIsValid] = useState(true);
  const [filtroHd, setFiltroHd] = useState(false);
  const [urlBase, setUrlBase] = useState(process.env.BASE_URL);
  const [productUrl, setProductUrl] = useState(process.env.PRODUCT_URL);

  useEffect(() => {
    setIsValid(pathName === '/gradedecanaisv2/');
  }, [pathName]);

  useEffect(() => {
    if (!isValid) {
      setListErrors(['Pagina não autorizada']);
    }
  }, [isValid]);

  // retorna categorias e dentro lista de canais no nivel de categoria nomedoPlano string
  //exclue nome do plano
  //filta o plano dentro da categoria
  // o " hd"1
  // setTheme(props.theme); TODO: johnny test

  const populaState = useCallback(async () => {
    await api
      .getFile({
        urlBase,
        productUrl,
        ...urlParameters,
      })
      .then((result) => {
        let errors = [];
        // console.log(result, 'result.');
        if (!result.error) {
          setplanName(result.planName);
          setCanaisDoPlano(result);
        } else {
          errors.push('tvId não encontrado');
        }

        if (errors.length === 0) {
          setLoading(false);
        } else {
          setListErrors(errors);
          setLoading(false);
        }
      });
  }, [urlParameters]);

  useEffect(() => {
    populaState();
  }, [populaState]);

  function changeOpenedCategorie(key) {
    if (key !== categoriaAberta) {
      // setFiltroHd(false);
      setCategoriaAberta(key);
    } else {
      setCategoriaAberta('');
    }
  }

  function channelSearch(event) {
    setBusca(event.target.value.toLowerCase());
  }

  function clearSearch() {
    setBusca('');
    setFiltroHd(false);
  }

  function openDisclaimer() {
    setDisclaimerOpen(!disclaimerOpen);
  }

  function changeCheck(event) {
    setFiltroHd(!filtroHd);
    setCategoriaAberta('');
  }

  return (
    <ThemeProvider theme={themeMy}>
      <div className="grade-canais mdn-Container-fluid">
        {loading && <Loader />}

        {listErrors.length === 0 && loading === false && (
          <React.Fragment>
            {/* Div Titulo e Pesquisa */}
            <div className="mdn-Row mdn-u-paddingBottom--md">
              <div className="mdn-Col-sm-5 mdn-Col-md-4" id="titulo">
                <div className="nome-plano mdn-Col-xs">
                  <Heading
                    planName={planName}
                  />
                </div>
              </div>

              {/* Pesquisa */}
              <div className={`mdn-Col-sm-7 mdn-Col-md-${tvName ? '8' : '12'}`}>
                <Search
                  busca={busca}
                  channelSearch={channelSearch}
                  clearSearch={clearSearch}
                  planoSelecionado={planoSelecionado}
                />

                {/* Checkbox */}
                <div className="mdn-Row mdn-u-paddingBottom--xs">
                  <div className="mdn-Col-xs">
                    <CheckBox changeCheck={changeCheck} isChecked={filtroHd} />
                  </div>
                </div>
              </div>
            </div>

            <div className="mdn-Row">
              <div className="mdn-Col-xs">
                {busca.length < 2 ? (
                  <Accordion
                    categorias={categorias}
                    canaisDoPlano={canaisDoPlano}
                    changeOpenedCategorie={changeOpenedCategorie}
                    categoriaAberta={categoriaAberta}
                    filtroHd={filtroHd}
                  />
                ) : (
                  <SearchRsult busca={busca} canaisDoPlano={canaisDoPlano} clearSearch={clearSearch} />
                )}
              </div>
            </div>

            <div className="mdn-Row">
              <div className="mdn-Col-xs">
                <Disclaimer disclaimerOpen={disclaimerOpen} openDisclaimer={openDisclaimer} />
              </div>
            </div>
          </React.Fragment>
        )}

        {listErrors.length !== 0 && loading === false && <ErrorList errors={listErrors} />}
      </div>
    </ThemeProvider>
  );
};

export default memo(App);
